module.exports = __webpack_public_path__ + "static/media/lane_back_arrow.7371bea7.svg";